const { Component } = Shopware;

Component.extend('sellops-color-picker', 'sw-text-field', {
    template: `
        <div class="sw-field sellops-color-picker-field">
            <div class="sw-block-field__block" style="display:flex; align-items:center; gap:8px;">

                <!-- Native colour swatch — clicking opens browser colour picker -->
                <input
                    type="color"
                    :value="currentValue || '#000000'"
                    @change="onSwatchChange"
                    style="width:38px; height:38px; flex-shrink:0; border:1px solid #d1d9e0;
                           border-radius:6px; padding:2px; cursor:pointer; background:none;"
                    :title="label"
                />

                <!-- Reuse the parent sw-text-field slot so label/helpText/validation all work -->
                <sw-text-field
                    style="flex:1; margin:0;"
                    :value="currentValue"
                    :label="label"
                    :helpText="helpText"
                    :placeholder="placeholder || 'e.g. #1a3fa4'"
                    :disabled="disabled"
                    @input="onTextInput"
                    @change="onTextChange"
                />
            </div>
        </div>
    `,

    data() {
        return {
            currentValue: this.value || '',
        };
    },

    watch: {
        value(val) {
            this.currentValue = val || '';
        },
    },

    methods: {
        onSwatchChange(event) {
            const val = event.target.value;
            this.currentValue = val;
            this.$emit('input', val);
            this.$emit('change', val);
        },

        onTextInput(val) {
            this.currentValue = val || '';
            this.$emit('input', this.currentValue);
            this.$emit('change', this.currentValue);
        },

        onTextChange(val) {
            this.currentValue = val || '';
            this.$emit('input', this.currentValue);
            this.$emit('change', this.currentValue);
        },
    },
});
